var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelMoreSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 4,
  viewBox: "0 0 16 4",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3 0c.557 0 1 .447 1 1v2c0 .557-.447 1-1 1H1c-.557 0-1-.447-1-1V1c0-.557.447-1 1-1zm6 0c.557 0 1 .447 1 1v2c0 .557-.447 1-1 1H7c-.557 0-1-.447-1-1V1c0-.557.447-1 1-1zm6 0c.557 0 1 .447 1 1v2c0 .557-.447 1-1 1h-2c-.557 0-1-.447-1-1V1c0-.557.447-1 1-1z"
})));
export default SvgChannelMoreSm;